import { Component, input } from "@angular/core";
import { FieldTree, FormField } from "@angular/forms/signals";
import { SiteTypeModel, SiteTypesFilterModel } from "./search-filter-sitetype.model";

@Component({
    selector: "search-filter-sitetype",
    imports: [FormField],
    templateUrl: "./search-filter-sitetype.component.html",
    styleUrl: "./search-filter-sitetype.component.scss",
})
export class SearchFilterSitetypeComponent {
    filterForm = input.required<FieldTree<SiteTypesFilterModel>>();

    toggleExpanded(): void {
        this.filterForm().expanded().value.set(!this.filterForm().expanded().value());
    }

    toggleSelectedSiteType(siteType: SiteTypeModel): void {        
        const current = this.filterForm().siteTypes().value();
        this.filterForm()
            .siteTypes()
            .value.set(current.map((e) => (e.index === siteType.index ? { ...e, selected: !e.selected } : e)));
    }

    selectAllSiteTypes(): void {
        if (this.checkIfAllSelected()) {
            this.filterForm().siteTypes().value.update((siteTypes: SiteTypeModel[]) => {
                return siteTypes.map((siteType) => {
                    return {
                        ...siteType,
                        selected: false,
                    };
                });
            });
        } else {
            this.filterForm().siteTypes().value.update((siteTypes: SiteTypeModel[]) => {
                return siteTypes.map((siteType) => {
                    return {
                        ...siteType,
                        selected: true,
                    };
                });
            });
        }
    }

    private checkIfAllSelected(): boolean {
        return this.filterForm()
            .siteTypes()
            .value()
            .every((siteType) => siteType.selected);
    }
}
